<template>
	<div>
		<OverviewTitleBox :title="'FUEL COCO'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">FUEL COCO</H6>
		</div>
		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCardComp icon="fa-chart-line" prefix="SALES" unit="KL" comp=1 :data="ytd.sales[3]" infocol="Info" valuecol="Value"
					:url="'/fuel/report2?tab=0&' + this.getYesterdayfilter('dateStart', 'dateEnd') + '&period=daily&area=area' + '&owner=COCO'"/>
				<InfoCardComp icon="fa-thumbs-down" prefix="LOSSES" unit="%" comp=-1 :data="ytd.losses[1]" infocol="Info" valuecol="Value"
					:url="'/fuel/report2?tab=1&' + this.getMTDfilter('dateStart', 'dateEnd') + '&period=monthly&area=area' + '&owner=COCO'"/>

				<InfoCardComp icon="fa-chart-line" prefix="TOTAL" unit="UNIT" :data="ytd.rekap[0]" infocol="Info" valuecol="Value" div=1 comp=1 url="/fuel/outlet?status=1"/> 
			</div>
			<div class="col-md-4">
				<InfoCardComp icon="fa-gas-pump" prefix="SALES" unit="KL" comp=1 :data="ytd.sales[0]" infocol="Info" valuecol="Value"
					:url="'/fuel/report2?tab=0&' + this.getYTDfilter('dateStart', 'dateEnd') + '&period=yearly&area=area' + '&owner=COCO'"/>
				<InfoCardComp icon="fa-star" prefix="REALISASI BBK" unit="%" comp=1 :data="ytd.bbk[0]" infocol="Info" valuecol="Value"
					:url="'/fuel/report2?tab=0&detail2=group&' + this.getYTDfilter('dateStart', 'dateEnd') + '&period=yearly&area=&detail2=group&owner=COCO'"/>
				<InfoCardComp icon="fa-cash-register" prefix="CASH TRX" unit="%" comp=-1 :data="ytd.pctcash[0]" infocol="Info" valuecol="Value"
					:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd') + '&period=yearly&area=&detail3=cash&owner=COCO'"/>
			</div>
			<div class="col-md-4">
				<ListItem warning=1 title="CRITICAL STOCK" :data="critical.product" itemcol="ProductName" valuecol="Cnt"
					url="/fuel/report2?tab=3&period=&area=area&detail1=station&detail2=product&status=CRITICAL&owner=COCO"/>
			</div>
		</div>
	</div>
</template>

<script>
import InfoCardComp from '@/views/pages/InfoCardComp.vue'
import ListItem from '@/views/pages/ListItem.vue'
import Fuel from '@/components/page/Fuel.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'

export default{
	extends: Fuel,
	components:{
		ListItem,
		InfoCardComp,
		OverviewTitleBox,
	},
    mounted(){
		this.loadYTD();
		this.loadCritical();
    },
    methods:{
		async loadYTD() {
			//
			let url = Config().apiURL+ "/v1/fuel2/ytd2?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=COCO";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data){
					this.ytd = {
						raw: result.data,
						sales: this.processYTD(result.data.summary, "Info", "SalesVolume", false, "Grup", 1000, 0),
						losses: this.processYTD(result.data.summary, "Info", "LossesVolume", "SalesVolume", "Grup", 0.01, 2),
						bbk: this.processYTD(result.data.summary, "Info", "SalesVolumeBBK", "SalesVolumeAll", "Grup", 0.01, 2),
						cash: this.processYTD(result.data.cash, "Info", "AmountCash", false, "Grup", 1, 2),
						noncash: this.processYTD(result.data.cash, "Info", "AmountNonCash", false, "Grup", 1, 2),
						pctcash: this.processYTD(result.data.cash, "Info", "AmountCash", "AmountAll", "Grup", 0.01, 2),
						rekap: this.processYTD(result.data.unit, "Info", "TotalUnit", false, "Grup", 1, 2),
					};
				}
			})
		},
		async loadCritical(satgas=0){			
			let url =Config().apiURL+"/fuel2/stock?satgas=" +satgas +"&status=CRITICAL&detail=product" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=COCO";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.product = result.data.data;
				}
			})
			url =Config().apiURL+"/fuel2/stock?status=CRITICAL&detail=area" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=COCO";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.area = result.data.data;
				}
			})
		},
	}
}

</script>